import React, { useEffect, useState } from 'react';
import { useCart } from '../context/CartContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { createPortal } from 'react-dom';

export default function FloatingCartButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const { cart } = useCart();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 640);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Hide on /cart, not mobile, or cart is empty
  if (!isMobile || location.pathname === '/cart' || cart.length === 0) return null;

  // Use cart.length to match the header's cart count behavior
  const totalItems = cart.length;

  const button = (
    <div
      style={{
        position: 'fixed',
        bottom: 130,
        right: 48,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pointerEvents: 'auto',
      }}
    >
      <button
        onClick={() => navigate('/cart')}
        aria-label={`View cart with ${totalItems} item${totalItems !== 1 ? 's' : ''}`}
        style={{
          background: '#fff',
          borderRadius: '50%',
          boxShadow: 'rgba(0, 51, 102, 0.3) 0px 4px 24px',
          padding: 12,
          border: '3px solid #003366',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          position: 'relative',
          width: 54,
          height: 54,
        }}
      >
        {/* Cart SVG icon for visual consistency */}
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#003366">
          <path d="M7 18c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm10 0c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zM7.334 16l.94-2h7.453c.825 0 1.558-.501 1.862-1.266l3.373-7.857A1 1 0 0 0 20 3H6.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 14.37 5.48 16 7 16h10v-2H7.334z"/>
        </svg>
        {/* Badge for item count */}
        <span style={{
          position: 'absolute',
          top: -6,
          right: -6,
          minWidth: 22,
          height: 22,
          background: '#fff',
          color: '#003366',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 13,
          fontWeight: 700,
          border: '2px solid #003366',
          boxShadow: '0 1px 4px 0 rgba(0,51,102,0.15)',
          pointerEvents: 'none',
        }}>
          {totalItems}
        </span>
      </button>
      <span style={{
        marginTop: 8,
        background: '#fff',
        color: '#003366',
        borderRadius: 8,
        padding: '2px 12px',
        fontSize: 14,
        fontWeight: 600,
        border: '2px solid #003366',
        boxShadow: '0 2px 10px 0 rgba(37,211,102,0.15)',
        textAlign: 'center',
        maxWidth: 140,
        letterSpacing: 0.1,
      }}>
        Cart
      </span>
    </div>
  );

  return typeof window !== 'undefined' ? createPortal(button, document.body) : null;
}
